import { getISONumbersOrder } from './getISONumbersOrder';

export const sortByISONumberOrder = (a: number, b: number) => {
  const ISO_NUMBERS_ORDER_MAP = getISONumbersOrder();

  return ISO_NUMBERS_ORDER_MAP.indexOf(a) - ISO_NUMBERS_ORDER_MAP.indexOf(b);
};
